var PreviewApiActions = /** @class */ (function () {
    function PreviewApiActions() {
    }
    PreviewApiActions.changeColors = 'changeColors';
    PreviewApiActions.changeHeaderFooterStyle = 'changeHeaderFooterStyle';
    PreviewApiActions.focusText = 'focusText';
    PreviewApiActions.leaveText = 'leaveText';
    PreviewApiActions.changeText = 'changeText';
    PreviewApiActions.changeLogoUrl = 'changeLogoUrl';
    PreviewApiActions.changeHeroImageUrl = 'changeHeroImageUrl';
    PreviewApiActions.changeHeroVideoUrl = 'changeHeroVideoUrl';
    return PreviewApiActions;
}());
export { PreviewApiActions };
//# sourceMappingURL=preview-api-actions.enum.js.map